import { useRule } from "../CreateRuleNew/RuleReducer";
import Button2 from "../../../Button/Button2";
import { Divider } from "primereact/divider";
import classes from "./RuleWizard.module.css";
import Button3 from "../../../Button/Button3";

const WizardStepTrigger = ({ pins, firmware, smartLocks, onNext }) => {
    const { dispatch } = useRule();

    const parts = (firmware || "0.0.0").split(".");
    const [maj, min, rev] = parts.map(Number);
    const supportsOutputPulse = maj > 2 || (maj === 2 && (min > 1 || (min === 1 && rev >= 1)));
    const supportsInputPulse = maj >= 2 || (maj === 1 && min >= 9);

    const handleGeofence = (direction) => {
        dispatch({ type: "SET_IS_GEOFENCE", payload: true });
        dispatch({ type: "SET_GEOFENCE_DIRECTION", payload: direction === "enter" ? "Enter" : "Exit" });
        if (pins.length > 0) {
            dispatch({ type: "SET_DEVICE_UUID", payload: pins[0].DeviceUUID });
        }
        dispatch({ type: "SET_ADV_RULE_ACTION", payload: [] });
        dispatch({ type: "SET_SELECTED_PINS_TO_AFFECT", payload: [] });
        onNext();
    };

    const handlePin = (pin) => {
        dispatch({ type: "SET_IS_GEOFENCE", payload: false });
        dispatch({ type: "SET_SELECTED_PIN", payload: pin });
        dispatch({ type: "SET_PIN_NUMBER", payload: pin.Pin });
        dispatch({ type: "SET_IS_LOCK", payload: smartLocks.some(l => parseInt(l.outputPin) === pin.Pin) });
        dispatch({ type: "SET_IS_REGULAR_OUTPUT", payload: smartLocks.every(l => parseInt(l.outputPin) !== pin.Pin) });
        dispatch({ type: "SET_IS_INPUT", payload: pin.type === "INPUT" || pin.type === "VIRTUAL_INPUT" });
        dispatch({ type: "SET_PIN_STATUS_ON", payload: pin.pinStatusOn });
        dispatch({ type: "SET_PIN_STATUS_OFF", payload: pin.pinStatusOff });
        dispatch({ type: "SET_DEVICE_UUID", payload: pin.DeviceUUID });
        dispatch({ type: "SET_SUPPORTS_OUTPUT_PULSE", payload: supportsOutputPulse });
        dispatch({ type: "SET_SUPPORTS_INPUT_PULSE", payload: supportsInputPulse });
        dispatch({ type: "SET_SITE_TYPE", payload: pin.DeviceType });
        dispatch({ type: "SET_PIN_NAME", payload: pin.pinName });
        dispatch({ type: "SET_IS_PULSE", payload: pin.type === "PULSE" || pin.type === "VIRTUAL_PULSE" });

        const condition = {
            condition_type: "STATE_CHECK",
            pin: pin.Pin,
            pin_name: pin.pinName,
            pin_state: pin.type === "PULSE" || pin.type === "VIRTUAL_PULSE" ? "PULSE" : pin.pin_state,
            trigger_method: pin.type === "PULSE" || pin.type === "VIRTUAL_PULSE" ? "PULSE" : "LATCH",
            trigger_method_type: "ANY",
            time_condition: "ANYTIME",
            days_of_week: ["0", "1", "2", "3", "4", "5", "6"],
            is_absence_condition: false,
        };

        dispatch({ type: "SET_ADV_RULE_CONDITION", payload: [condition] });
        dispatch({ type: "SET_CONDITION_EDIT_INDEX", payload: 0 });
        dispatch({ type: "SET_ADV_RULE_ACTION", payload: [] });
        dispatch({ type: "SET_SELECTED_PINS_TO_AFFECT", payload: [] });
        dispatch({ type: "SET_INPUT_TYPE", payload: -1 });
        dispatch({ type: "SET_INPUT_TYPE_COPY", payload: -1 });
        onNext();
    };

    return (
        <>
            <div className={classes.contentHeader}>
                <h2 className={classes.contentTitle}>What triggers this rule?</h2>
                <p className={classes.contentSubtitle}>Choose a switch</p>
            </div>
            <div style={{ flex: 1, overflowY: "auto", display: "flex", flexDirection: "column", gap: "20px" }}>
                {/* <div>
                    <h4 style={{ color: "#6e6e6e", margin: "0 0 10px 0", fontSize: "13px", fontWeight: 600 }}>Geofence</h4>
                    <div className={classes.pinGrid}>
                        <Button3 style={{ minWidth: "210px", minHeight: "44px" }} onClick={() => handleGeofence("enter")}>
                            When first person enters zone
                        </Button3>
                        <Button3 style={{ minWidth: "210px", minHeight: "44px" }} onClick={() => handleGeofence("exit")}>
                            When last person exits zone
                        </Button3>
                    </div>
                </div> */}

                {/* <Divider align="center">
                    <span style={{ color: "#9e9e9e", fontSize: "13px" }}>or</span>
                </Divider> */}

                <div>
                    {/* <h4 style={{ color: "#6e6e6e", margin: "0 0 10px 0", fontSize: "13px", fontWeight: 600 }}>Switch</h4> */}
                    <div className={classes.pinGrid}>
                        {pins.map((pin, i) => (
                            <Button3 key={i} style={{ minWidth: "150px", minHeight: "44px" }} onClick={() => handlePin(pin)}>
                                {pin.pinName}
                            </Button3>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default WizardStepTrigger;
